<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div style="display: flex;">
          <div style="margin-right: 10px;">
            <el-date-picker
              v-model="querydate"
              type="daterange"
              size="small"
              value-format="timestamp"
              start-placeholder="查询开始日期"
              range-separator="至"
              end-placeholder="查询结束日期"
              @blur="getDate"
              @focus="cleradate"
            >
            </el-date-picker>
          </div>
          <div style="display: flex;">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchFilter.fastSearchKeyWord"
              clearable
              :placeholder="placeholder"
            />
            <div style="margin-left: 10px;">
              <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="btnQuery"
              >查询</el-button
            >
            </div>
          </div>
        </div>
      </div>
      <div slot="toolBar" class="search-btn" style="margin-right: 80%">
        <el-row>
          <el-col :span="24">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              type="danger"
              >新增
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Id"
            label="捐赠单号"
            :show-overflow-tooltip="true"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="ProjectName"
            label="捐赠项目"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Name"
            label="捐款者"
            :show-overflow-tooltip="true"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="Amount"
            label="捐赠金额"
            width="100"
            align="right"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>￥{{ scope.row.Amount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Donation"
            label="捐赠者类型"
            align="center"
            :formatter="formatterdonation"
            width="110"
          ></el-table-column>
          <el-table-column
            prop="DataSource"
            label="数据来源"
            align="center"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="IsReceiving"
            label="状态"
            align="center"
            width="80"
            :formatter="formatterstatus"
          ></el-table-column>
          <el-table-column
            prop="FinishTime"
            label="捐赠时间"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              {{ (scope.row.FinishTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="CreateTime"
            label="创建时间"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="innerQuery(scope.row)"
                type="text"
                size="mini"
                >详情
              </el-button>
              <el-button
                v-show="isRece(scope.row)"
                v-access:modify
                @click="innerRece(scope.row)"
                type="text"
                size="mini"
                >确认收货
              </el-button>
              <el-button
                v-show="isDel(scope.row)"
                v-access:delete
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除
              </el-button>
              <el-button
                v-access:modify
                @click="innerPrint(scope.row)"
                type="text"
                size="mini"
                >打印
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="pageIndex"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :form="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <ModuleQuery
      v-if="formVisibleQuery"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBackQuery"
    ></ModuleQuery>
    <ModulePrint
      v-if="showPrint"
      :dataForm="formData"
      @formCallBack="formCallBackQuery"
    ></ModulePrint>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/donation/donationmaterials/edit";
import ModuleQuery from "@/modules/zjrc/pages/donation/donationmaterials/query";
import ModulePrint from "@/modules/zjrc/pages/donation/donationmaterials/print";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false, //加载控制
      listData: [], //列表数据
      headerRow: "header-row",
      formVisible: false, //新增页面控制
      formVisibleQuery: false, //详情页面控制
      formTitle: "", //页面标题
      formData: {}, //表单数据
      total: 0, //总数
      pageIndex: 1, //页码
      pageSize: 15, //每页数据
      searchFilter: {
        fastSearchKeyWord: "", //关键字搜索
      },
      placeholder: "单号 / 捐赠项目 / 捐赠者名称",
      querydate: "", //查询日期
      startdate: 0, //开始日期
      enddate: 0, //结束日期
      showPrint: false,
    };
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
    ModuleQuery,
    ModulePrint,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    // //确认到账按钮
    isRece() {
      return (rowData) => {
        if (rowData.Status == 1 && rowData.DataSource == "系统") {
          return rowData.IsReceiving == 0 ? true : false;
        }
      };
    },
    //删除按钮
    isDel() {
      return (rowData) => {
        return rowData.DataSource == "录入" ? true : false;
      };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    cleradate() {
      this.querydate = "";
      this.startdate = "";
      this.enddate = "";
    },
    //查询日期
    getDate() {
      if (this.querydate !== "") {
        this.startdate = this.querydate[0] / 1000;
        this.enddate = this.querydate[1] / 1000;
      }
    },
    //状态
    formatterstatus(item) {
      switch (item.IsReceiving) {
        case 0:
          return "待收货";
        case 1:
          return "已收货";
      }
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        fastSearchKeyWord: this.searchFilter.fastSearchKeyWord,
        startdate: this.startdate,
        enddate: this.enddate,
      };
      api.QueryDonationMaterials(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //新增
    add() {
      this.formTitle = "新增物品捐赠";
      this.formData = { Creator: this.GetCurrentUserInfo.Id };
      this.formVisible = true;
    },
    //删除
    innerDel(row) {
      let selt = this;
      this.$confirm("删除记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = { Id: row.Id };
          api.DeleteDonationMaterials(params).then(function (res) {
            if (res.data.Code === 0) {
              selt.$message({
                type: "success",
                message: "删除成功!",
              });
              selt.loadData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //按钮搜索
    btnQuery() {
      this.loadData();
    },
    //关键字查找
    search(keyword) {
      this.searchFilter.fastSearchKeyWord = keyword;
      this.loadData();
    },
    //查看详情
    innerQuery(rowData) {
      this.formData = Object.assign({}, rowData);
      this.formTitle = "查看详情";
      this.formVisibleQuery = true;
    },
    innerPrint(rowData) {
      let that = this;
      that.formData = Object.assign({}, rowData);
      that.showPrint = true;
    },
    //捐赠者类型
    formatterdonation(item) {
      return item.Donation === 1 ? "个人" : "企业";
    },
    //新增回调
    formCallBack(data) {
      this.formVisible = false;
      if (data != null) {
        this.loadData();
      }
    },
    //查看详情回调
    formCallBackQuery() {
      let that = this;
      that.formVisibleQuery = false;
      that.showPrint = false;
    },
    //确认收货
    innerRece(row) {
      let self = this;
      this.$confirm("是否确认收货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: row.Id };
        api.UpdateMaterialsReceiving(params).then(function (res) {
          if (res.data.Code === 0) {
            self.$message({
              type: "success",
              message: "确认收货!",
            });
            self.loadData();
          }
        });
      });
    },
    //改变每页条数
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.pageIndex = val;
        this.loadData();
      }
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}

/* .el-select >>> .el-input__inner {
      width: 120px;
    } */
</style>

<style>
.searchbox {
  float: left;
  margin-right: 1%;
}

.searchbox_right {
  float: right;
  margin-right: 1%;
  widows: 100%;
}
</style>
